module.exports = {"150927103":"科布尔镇","150927104":"铁沙盖镇","150927105":"黄羊城镇","150927106":"广益隆镇","150927107":"乌素图镇","150927216":"大滩乡","150927217":"宏盘乡","150927218":"巴音乡","150927219":"库联苏木","150927220":"乌兰哈页苏木","150927221":"察右中旗土城子乡","150927400":"辉腾锡勒园区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150927.json
// module id = 473
// module chunks = 0